/**
 * vivaplancha-color-gallery.js
 * Filtre la galerie produit via metafield custom.variante_visuel
 *
 * Convention alt image :  "Photo ::visuel:citron,sel"
 * Convention metafield  :  custom.variante_visuel = "citron"
 */

(function () {
  'use strict';

  var TAG = '::visuel:';

  function initColorGallery(sectionId, productData) {
    if (!productData || !productData.variants || !productData.variants.length) return;

    // Changement de variante
    document.addEventListener(
      'eurus:product-page-variant-select:updated:' + sectionId,
      function () {
        var variantId = getSelectedVariantId(sectionId);
        if (!variantId) return;
        var variant = productData.variants.find(function (v) { return v.id === variantId; });
        if (!variant || !variant.variante_visuel) return;
        filterGallery(sectionId, parseSlugs(variant.variante_visuel));
      }
    );

    // Chargement initial — retry jusqu'à ce que le splide soit prêt
    applyWhenReady(sectionId, productData);
  }

  function applyWhenReady(sectionId, productData) {
    var variantId = getSelectedVariantId(sectionId);
    if (!variantId) return;
    var variant = productData.variants.find(function (v) { return v.id === variantId; });
    if (!variant || !variant.variante_visuel) return;
    var slugs = parseSlugs(variant.variante_visuel);

    var splideEl = document.getElementById('x-product-' + sectionId);
    if (!splideEl) return;

    // Si déjà initialisé
    if (splideEl.splide) {
      filterGallery(sectionId, slugs);
      return;
    }

    // Sinon observer les changements de classe (Splide ajoute is-initialized)
    var observer = new MutationObserver(function(mutations, obs) {
      if (splideEl.classList.contains('is-initialized') || splideEl.splide) {
        obs.disconnect();
        filterGallery(sectionId, slugs);
      }
    });
    observer.observe(splideEl, { attributes: true, attributeFilter: ['class'] });

    // Fallback : écouter l'event Eurus
    document.addEventListener('eurus:media-gallery-ready:' + sectionId, function() {
      observer.disconnect();
      filterGallery(sectionId, slugs);
    }, { once: true });
  }

  function filterGallery(sectionId, slugs) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var splideEl = document.getElementById('x-product-' + sectionId);
    var allMedias = Array.from(section.querySelectorAll('[data-media-id]'));

    allMedias.forEach(function (el) {
      var img = el.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var hasTag = alt.indexOf(TAG) !== -1;
      var visible = !hasTag || matchSlugs(alt, slugs);

      if (el.classList.contains('media-slide') || el.classList.contains('splide__slide')) {
        // Slides — utiliser splide__slide pour show/hide
        if (visible) {
          el.classList.add('splide__slide');
          el.style.display = '';
        } else {
          el.classList.remove('splide__slide');
          el.style.display = 'none';
        }
      } else {
        // Thumbnails
        if (visible) {
          el.style.display = '';
          el.removeAttribute('hidden');
        } else {
          el.style.display = 'none';
          el.setAttribute('hidden', 'hidden');
        }
      }
    });

    // Refresh Splide
    if (splideEl && splideEl.splide) {
      splideEl.splide.refresh();
      splideEl.splide.go(0);
    }
  }

  function matchSlugs(alt, slugs) {
    var idx = alt.indexOf(TAG);
    if (idx === -1) return false;
    var raw = alt.slice(idx + TAG.length).split(' ')[0];
    var altSlugs = raw.split(/[,|]/).map(function (s) { return s.trim(); });
    return slugs.some(function (s) { return altSlugs.indexOf(s) !== -1; });
  }

  function parseSlugs(raw) {
    if (!raw) return [];
    return raw.split(/[,|]/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function getSelectedVariantId(sectionId) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return null;
    var input = section.querySelector('input[name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    if (match) return parseInt(match[1], 10);
    return null;
  }

  window.vivaColorGallery = { init: initColorGallery };

})();
